export interface Campaign {
	CampaignId: number | null;
	CampaignNumber: string | null;
	SectionId: number | null;
	SectionName: string | null;
	BilletSize: number | null;
	Description: string | null;
	TonsPerHour: number | null;
	MillYield: number | null;
	FinishedYield: number | null;
	HeatId: number | null;
	HeatName: string | null;
	GradeId: number | null;
	GradeName: string | null;
	Start: Date;
	End: Date | null;
	Duration: number | null;
	ChargedBillets: number | null;
	ChargedColdTons: number | null;
	ChargedHotTons: number | null;
	RolledBillets: number | null;
	RolledColdTons: number | null;
	RolledHotTons: number | null;
	RejectedBillets: number | null;
	RejectedColdTons: number | null;
	RejectedHotTons: number | null;
	TotalDelayTime: number | null;
	DelayTimePercent: number | null;
	Cobbles: number | null;
	SampleStatusCode: "P" | "R" | "U";
	SampleStatusTimestamp: Date | null;
	SampleStatusUser: string | null;
	IsSampleStatusPending: boolean | null;
	IsDuplicate: boolean | null;
}

export const CAMPAIGN_INITIAL_VALUES: Campaign = {
	CampaignId: null,
	CampaignNumber: null,
	SectionId: null,
	SectionName: "",
	BilletSize: null,
	Description: "",
	TonsPerHour: null,
	MillYield: null,
	FinishedYield: null,
	HeatId: null,
	HeatName: "",
	GradeId: null,
	GradeName: "",
	Start: new Date(),
	End: null,
	Duration: null,
	ChargedBillets: null,
	ChargedColdTons: null,
	ChargedHotTons: null,
	RolledBillets: null,
	RolledColdTons: null,
	RolledHotTons: null,
	RejectedBillets: null,
	RejectedColdTons: null,
	RejectedHotTons: null,
	TotalDelayTime: null,
	DelayTimePercent: null,
	Cobbles: null,
	SampleStatusCode: "U",
	SampleStatusTimestamp: null,
	SampleStatusUser: "",
	IsSampleStatusPending: false,
	IsDuplicate: false,
};
